import React from 'react';
import { Modal, Button } from 'antd';
import { X } from 'lucide-react';
import styles from './LogoutConfirmModal.module.css';

export interface LogoutConfirmModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  loading?: boolean;
}

export const LogoutConfirmModal: React.FC<LogoutConfirmModalProps> = ({
  open,
  onClose,
  onConfirm,
  loading = false,
}) => {
  const handleConfirm = async () => {
    await onConfirm();
  };

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      closeIcon={<X size={20} />}
      className={styles.modal}
      width={400}
      destroyOnHidden
    >
      <div className={styles.modalContent}>
        <h2 className={styles.modalTitle}>Đăng xuất?</h2>
        
        <p className={styles.modalDescription}>
          Hành động này sẽ kết thúc phiên đăng nhập hiện tại.
        </p>

        <div className={styles.modalFooter}>
          <Button
            type="default"
            onClick={onClose}
            className={styles.cancelButton}
          >
            Hủy
          </Button>
          <Button
            type="primary"
            onClick={handleConfirm}
            loading={loading}
            className={styles.confirmButton}
          >
            Đồng ý
          </Button>
        </div>
      </div>
    </Modal>
  );
};
